/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

import React from 'react';
import './index.css'
import NavBar from './NavBar';
import InformationContainer from '../../elements/InformationContainer';
import InformationContainerItem from '../../../types/elements/InformationContainerItem';
import Route from '../../../types/Route';
import TrustImages from './TrustImages/TrustImages';
import Constants from '../../../Constants';

const Header = (props: {
    currentRoute: Route,
    image: JSX.Element|null,
    informationContainerItem: InformationContainerItem|null,
    width: number,
}) => {
    const {currentRoute, image, informationContainerItem, width} = props;
    return (
        <div id="header">
            <NavBar currentRoute={currentRoute} width={width} />
            {image ? (
                <div id="headerImage">
                    {image}
                </div>
            ) : null}
            <div id="topInformationContainerWrapper">
                {informationContainerItem ? (
                    <InformationContainer id="mainInformationContainer" item={informationContainerItem} width={width} />
                ) : null}
                {width > Constants.LayoutBreakpoints.desktop && currentRoute.index ? (
                    <TrustImages />
                ) : null}
            </div>
        </div>
    )
}

export default Header
